let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jC3eu")).then(() => parcelRequire('1GfCc'));